import i18n from '../../language/index'
import linkData from '@/base/linkData'
import { create_font_set } from './../../base/fontSetData'
import img_effects from '@/base/img_effects'
export default {
  img_effects, //不知道这个是啥 但是去掉会报错
  /* animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation', */
  animation_set: {
    /* duration: 0,
    delay: 0, */
    start: 0,
    end: 100,
    useGrouping: false, // 千分位分组
    decimalPlaces: 0, //小数位 的个数 0 -6
    desc: '' // 单位
  },
  pc_widgets_infor: {
    // title:create_font_set()// 文字设置

    ...create_font_set(),
    font: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor_globalColor:'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'center',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor_globalColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    playSet: { // 播放设置
      radio_val: 'default',
      default: {
        duration: 10,
        delay: 0.1
      },
      custom: {
        duration: 10,
        delay: 0.1
      }
    },
   //背景
    background:{
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(144,202,248, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      },
      custom:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(144,202,248, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      }
    },
  },
  mb_widgets_infor: {
    // title:create_font_set()// 文字设置
    ...create_font_set(),
    font: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor_globalColor:'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'center',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor_globalColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    //背景
    background:{
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(144,202,248, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      },
      custom:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(144,202,248, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      }
    },
  },
  listArr: {
    title: i18n.t('widgets_basic_magic_number_style_2582'),
    link: linkData
  },
  /* pc_infor:{
    marginTop:'0%',
    marginLeft:'40%',
    marginRight:'40%',
    marginBottom:'0%',
    textAlign: 'center'
  },
  mb_infor:{
    marginTop:'0%',
    marginLeft:'20%',
    marginRight:'20%',
    marginBottom:'0%',
    textAlign: 'center'
  }, */
}



// WEBPACK FOOTER //
// ./src/widgets/basic_magic_number/style.js